import { PDF_SANITIZE_OPTIONS } from '@realadvisor/common-types';

const EDITOR_HOOK_ATTRIBUTES = {
  main: ['id'],
  body: ['id'],
};

const PREVIEW_DROPPED_TAGS = new Set(['iframe']);
const PREVIEW_DROPPED_ATTRIBUTES = new Set(['onerror']);

const PDF_PREVIEW_SANITIZE_OPTIONS = {
  ...PDF_SANITIZE_OPTIONS,
  allowedTags: PDF_SANITIZE_OPTIONS.allowedTags.filter(
    tag => !PREVIEW_DROPPED_TAGS.has(tag),
  ),
  allowedAttributes: {
    ...Object.fromEntries(
      Object.entries(PDF_SANITIZE_OPTIONS.allowedAttributes)
        .filter(([tag]) => !PREVIEW_DROPPED_TAGS.has(tag))
        .map(([tag, attributes]) => [
          tag,
          attributes.filter(
            attribute => !PREVIEW_DROPPED_ATTRIBUTES.has(attribute),
          ),
        ]),
    ),
    ...Object.fromEntries(
      Object.entries(EDITOR_HOOK_ATTRIBUTES).map(([tag, attributes]) => [
        tag,
        [...(PDF_SANITIZE_OPTIONS.allowedAttributes[tag] ?? []), ...attributes],
      ]),
    ),
  },
  allowedSchemesByTag: { a: ['http', 'https', 'mailto', 'tel'] },
};

let sanitizer: ((html: string) => string) | null = null;

export const loadPdfPreviewSanitizer = async (): Promise<void> => {
  if (sanitizer == null) {
    const { default: sanitizeHtml } = await import('sanitize-html');
    sanitizer = html => sanitizeHtml(html, PDF_PREVIEW_SANITIZE_OPTIONS);
  }
};

export const sanitizeLikePdf = (html: string): string => {
  if (sanitizer == null) {
    throw new Error(
      'loadPdfPreviewSanitizer() must finish before a document is rendered',
    );
  }
  return sanitizer(html);
};
